<template>
  <div class="editeventclass eventdata container-fluid">
    <div class="container-fluid">
      <div class="row" id="dashboardCardDiv">
        <div class="col-md-12">
          <div class="card card-transparent-background mb-0">
            <div class="card-header row pb-0">
              <div class="col-12 pl-0">
                <h4 class="card-title card-title-doom-yoga">Edit Event</h4>
              </div>
            </div>
          </div>
          <div class="createeventCard">
            <EventInfo
              client_name="DY"
              field_name="class"
              event_type="class"
              action="update"
              :locations="locations"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import EventInfo from "@/components/events/EventInfo.vue";

export default {
  name: "EditEvent",
  components: { EventInfo },
  data() {
    return {
      locations: [
        { text: "ZOOM ONLINE", id: "ZOOM ONLINE" },
        { text: "Kimberley Street, London", id: "Kimberley Street, London" },
        { text: "Dublin, Ireland", id: "Dublin, Ireland" },
        { text: "Studio Doom Yoga, London", id: "Studio Doom Yoga, London" },
      ],
    };
  },
};
</script>


// WEBPACK FOOTER //
// src/components/doom_yoga/events/EditEventClass.vue